import React from 'react';
import { MenuItem, Select, SelectChangeEvent } from '@mui/material';
import { ICellRendererParams } from 'ag-grid-community';
import { styles } from './SelectCellRenderer.styles';

export interface ISelectCellRendererParams<TData = unknown> extends ICellRendererParams<TData> {
  readonly value: string;
  readonly selectOptions: { label: string; value: string }[];
  readonly disabled?: boolean;
  readonly ariaLabel?: string;
  readonly onChange: (value: string, data: TData) => void;
}

export function SelectCellRenderer<TData = unknown>({
  value,
  disabled = false,
  selectOptions,
  ariaLabel,
  data,
  onChange
}: ISelectCellRendererParams<TData>) {
  const handleChange = (event: SelectChangeEvent) => {
    onChange(event.target.value, data as TData);
  };

  return (
    <Select
      sx={styles.container}
      value={value}
      disabled={disabled}
      variant="outlined"
      inputProps={ariaLabel ? { 'aria-label': ariaLabel } : undefined}
      onChange={handleChange}
    >
      {selectOptions.map(({ label, value }) => (
        <MenuItem key={label} value={value}>
          {label}
        </MenuItem>
      ))}
    </Select>
  );
}
